import { CREATION_STATES, RULE_COLORS } from "./constants";

/**
 * COLORS RULES
 *
 * - Green: Indicates a system-generated record (record.creation_state = 'SYSTEM').
 * - Yellow: Indicates a change in the record (property ends with '_changed').
 * - Red: To Be Determined (TBD).
 * 
 * We have field like flag called (XXXXX_changed) to indicate changes in the record.
 * and we use creation_state to know if the record was created by the system or not.
 * 
 * NOTE: CREATION_STATES always will come empty, because we are not using it in the report for a while.
 */
export const getColumnColor = ({ record, dataIndex }) => {
  if (!record) return null;

  const creationState = record?.creationState?.toUpperCase() || CREATION_STATES.SYSTEM_MODIFIED;
  const recordChanged = record?.[dataIndex] || null;

  if (creationState === CREATION_STATES.SYSTEM && !recordChanged) {
    return RULE_COLORS.G;
  }

  if (recordChanged) {
    return RULE_COLORS.Y;
  }

  return null;
};

